<template>
    <b-row no-gutters id="footer" align-v="center">
        <b-col cols="1"></b-col>
        <b-col cols="5" class="text-left">
            <a href="https://www.livroreclamacoes.pt/" target="_blank">
                <img
                    src="/assets/img/livro-reclamacoes-120x50-w.png"
                    alt="Livro de Reclamações Online"
                />
            </a>
        </b-col>
        <b-col cols="5">
            <p class="whiteBarbos textFooter">
                &copy; 2019 Barbosa Peixe. Todos os direitos reservados.
                <br />
                Rua São Sebastião 21, 4450-267 Matosinhos | 229 371 704 |
                <a href="mailto:barbosapeixe@sapo.pt ">barbosapeixe@sapo.pt</a>
            </p>
            <p>
                <a href="/docs/condicoes_gerais.pdf" target="_blank">
                    Regulamento Geral de Proteção de Dados
                </a>
            </p>
        </b-col>
        <b-col cols="1"></b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Footer',
    props: {}
}
</script>
